import { render, staticRenderFns } from "./NewAMForgotUsrnmComponent.vue?vue&type=template&id=4b9be584&scoped=true"
import script from "./NewAMForgotUsrnmComponent.vue?vue&type=script&lang=js"
export * from "./NewAMForgotUsrnmComponent.vue?vue&type=script&lang=js"
import style0 from "./NewAMForgotUsrnmComponent.vue?vue&type=style&index=0&id=4b9be584&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9be584",
  null
  
)

export default component.exports